import { useQuery } from "@tanstack/react-query";
import { useDocumentService } from "contexts/ServiceContext";
import { AI_EVENTS, useTrackEvent } from "../../../useAppInsight";
import mapApiDocumentFilterDimensions from "./mapApiDocumentFilterDimensions";

const useGetDocumentOrderFilterDimensions = (cardCodes: string[]) => {
  const documentService = useDocumentService();

  const trackQuery = useTrackEvent(AI_EVENTS.API_REQUEST, {
    cardCodes,
  });

  const trackQueryError = useTrackEvent(AI_EVENTS.API_ERROR, {
    cardCodes,
  });

  return useQuery({
    queryKey: ["documentOrderFilterDimensions", { cardCodes }],
    queryFn: () => {
      const eventId = trackQuery({
        endpoint: "/Order/GetDocumentFilterDimensions",
      });
      return documentService
        .getDocumentOrderFilterDimensions(cardCodes)
        .then((data) => mapApiDocumentFilterDimensions(data))
        .catch((err) => {
          trackQueryError(
            {
              statusCode: err.statusCode as number,
              message: err.message,
            },
            eventId
          );
          throw err;
        });
    },
  });
};

export default useGetDocumentOrderFilterDimensions;
